/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { DomainAuthCode } from "../../models/domain-auth-code";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface GetAuthCode$Params {
  organisation_id: string;
  domain_id: string;
  refresh?: boolean;
}

export function getAuthCode(
  http: HttpClient,
  rootUrl: string,
  params: GetAuthCode$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<DomainAuthCode>> {
  const rb = new RequestBuilder(rootUrl, getAuthCode.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("domain_id", params.domain_id, {});
    rb.query("refresh", params.refresh, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DomainAuthCode>;
    }),
  );
}

getAuthCode.PATH = "/surfdomeinen/organisations/{organisation_id}/domains/{domain_id}/auth_code";
